import React, { useEffect, useState } from 'react'
import ReactApexChart from 'react-apexcharts';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { getListBar, getListPeopleCount } from '../../redux/action/summaryAction';
import { Card, CardBody, CardHeader } from 'react-bootstrap';
import moment from 'moment'

const Bar = () => {
    const dispatch = useDispatch()
     const { dataBar } = useSelector((state) => state.summary)
     const [todayDate , setToday] = useState(moment().format('YYYY-MM-DD'))
     let { siteId } = useParams()
     const { user } = useSelector((state) => state.auth)
     const param = {
       token: user.access_token,
       siteId: siteId,
       dates: todayDate
     }
    useEffect(() => {
        dispatch(getListBar(param));
    }, []);
    // const chartOptions = {
    //     chart: {
    //       type: 'bar',
    //       stacked: true ,
    //     },
    //     xaxis: {
    //       categories: dataBar.map((item) => item.time),
    //     },
    //   };
      const categories = Array.from(new Set(dataBar.map((entry) => entry.time)))
      const sensorNames = Array.from(new Set(dataBar.flatMap((entry) => entry.value.map((sensor) => sensor.sensorName))))
      const series = sensorNames.map((sensorName) => {
        // const sensorData = dataBar.filter((entry) => entry.value.find((sensor) => sensor.sensorName === sensorName))
        const sensorValues = dataBar.map((entry) => {
        const sensor = entry.value.find((sensor) => sensor.sensorName === sensorName);
         return sensor ? sensor.sum : 0;
        });

      return {
        name: sensorName,
        data: sensorValues,
      };
    });
    const chartOptions = {
      chart: {
        type: 'bar',
        stacked: true,
        toolbar: {
          show: false,
        },
        zoom: {
          enabled: false,
        },
      },
      xaxis: {
        categories,
        labels: {
          show: true,
          style: {
            colors: '#fff',
          },
        },
      },
      legend: {
        position: 'bottom',
        color: 'white',
        horizontalAlign: 'center',
        labels: {
          colors: 'white',
          useSeriesColors: false,
        },
      },
    };
    
      // const series = [
      //   {
      //     name: dataBar.map((item) => item.value[0].sensorName),
      //     data: dataBar.map((item) => item.value[0].sum),
      //     color: "#03e8fc",
      //   },
        
      // ];
    
      return (
      <Card className="mb-3">
        <CardHeader> 
          <span className="flex-grow-1 fs-15px"> 
            Statistik PENGGUNA JPO (PER-JAM)
          </span>
        </CardHeader>
        <CardBody>
          <ReactApexChart
          options={chartOptions}
          series={series}
          type="bar"
          width="100%"
        />
        </CardBody>
      </Card>
    )
}

export default Bar